const mainItems = document.querySelectorAll(".custom-main");

mainItems.forEach((main) => {
  const media = main.querySelector(".hero-ornate-grid__media");
  const card = main.querySelector(".hero-ornate-grid__card");

  if (!media || !card) return;

  gsap.set(card, {
    perspective: 650
  });

  const rotateX = gsap.quickTo(media, "rotationX", {
    duration: 0.4,
    ease: "power3"
  });

  const rotateY = gsap.quickTo(media, "rotationY", {
    duration: 0.4,
    ease: "power3"
  });

  const moveX = gsap.quickTo(media, "x", {
    duration: 0.4,
    ease: "power3"
  });

  const moveY = gsap.quickTo(media, "y", {
    duration: 0.4,
    ease: "power3"
  });

  main.addEventListener("pointermove", (e) => {
    const x = e.offsetX / main.offsetWidth;
    const y = e.offsetY / main.offsetHeight;

    rotateX(gsap.utils.interpolate(10, -10, y));
    rotateY(gsap.utils.interpolate(-10, 10, x));

    moveX(gsap.utils.interpolate(-10, 10, x));
    moveY(gsap.utils.interpolate(-10, 10, y));
  });

  main.addEventListener("pointerleave", () => {
    rotateX(0);
    rotateY(0);
    moveX(0);
    moveY(0);
  });
});